import { Helmet } from 'react-helmet-async';
import { Alert, Box, Container, Stack, Typography } from '@mui/material';

export default function MeasureStubPage({ title, body }) {
  return (
    <>
      <Helmet><title>{title} | Measure</title></Helmet>
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Box>
            <Typography variant="h4" sx={{ mb: 1 }}>{title}</Typography>
            {body && <Typography color="text.secondary">{body}</Typography>}
          </Box>
          <Alert severity="info">Coming up in Phase 1.</Alert>
        </Stack>
      </Container>
    </>
  );
}
